<!-- 发票信息 -->
<template>
  <base-form
    v-model="formData"
    :options="options"
    :disabled="!canEdit"
    ref="topData"
    :rules="rules"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseForm from '@/components/form/base-form';
  export default {
    name: 'invoiceInfo',
    components: {
      BaseForm,
    },
    props: {
      companyList: {
        type: Array,
        default: () => [],
      },
      canEdit: {
        type: Boolean,
        default: false,
      },
      invoiceInfo: {
        type: Object,
        default: () => {},
      },
      mobileList: {
        type: Array,
        default: () => [],
      },
      emailList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      options() {
        // const data = this.formData;
        return [
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.openBankCode'),
            prop: 'openBankName',
            required: this.formData.ifPersonalPartner == '1' ? false : true,
            filterable: true,
            clearable: true,
          }, //开户银行
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.bankAccount'),
            prop: 'bankAccount',
            clearable: true,
            required: this.formData.ifPersonalPartner == '1' ? false : true,
            filterable: true,
          }, //银行账号
          {
            type: 'input',
            label: '统一社会信用代码',
            prop: 'creditCode',
            clearable: true,
            required: true,
            disabled: true,
          }, //统一社会信用代码
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.partnerAddress'),
            prop: 'partnerAddress',
            clearable: true,
            maxlength: 80,
            required: this.formData.ifPersonalPartner == '1' ? false : true,
            disabled: true,
          }, //客户地址
          {
            type: 'dict',
            label: this.$t('financeSalesInvoice.column.goldenTaxType'),
            prop: 'goldenTaxType',
            required: true,
            clearable: true,
            dictType: 'golden_tax_type',
          }, //增值税发票类型
          {
            type: 'date',
            label: this.$t('financeSalesInvoice.column.goldenTaxDate'),
            prop: 'goldenTaxDate',
            clearable: true,
            disabled: true,
          }, //开票日期
          {
            type: 'input',
            label: '联系方式',
            prop: 'partnerPhone',
            required: this.formData.ifPersonalPartner == '1' ? false : true,
            clearable: true,
            disabled: true,
          },
          {
            type: 'select',
            label: '移动电话',
            prop: 'mobilePhone',
            options: this.mobileList,
            clearable: true,
          },
          {
            type: 'select',
            label: '邮箱',
            prop: 'partnerEmail',
            clearable: true,
            options: this.emailList,
          },

          // ...(this.formData.ifPersonalPartner == 1
          //   ?
          //   : []),
          // {
          //   type: 'dict',
          //   label: this.$t('financeSalesInvoice.column.goldenTaxStatus'),
          //   prop: 'goldenTaxStatus',
          //   disabled: true,
          //   clearable: true,
          //   dictType: '',
          // }, //金税发票单据状态
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      rules() {
        return {
          openBankName: [
            {
              required: true,
              message: this.$t('financeSalesInvoice.placeholder.openBankCodePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          bankAccount: [
            {
              required: true,
              message: this.$t('financeSalesInvoice.placeholder.bankAccountPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          goldenTaxType: [
            {
              required: true,
              message: this.$t('financeSalesInvoice.placeholder.goldenTaxTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
            // { validator: invoiceTypeValidate, trigger: ["blur", "change"] }
          ],
          partnerPhone: [
            {
              required: true,
              message: this.$t('financeSalesInvoice.placeholder.partnerPhonePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
    },
    watch: {
      'invoiceInfo.businessType': {
        handler(val) {
          // 业务类别为多式联运时，默认增值税发票类型为“电子专用发票”
          // 为贸易时，不默认也不自动带出
          if (this.$route.name == 'saleInvoiceAdd') {
            if (val == '02') {
              this.formData.goldenTaxType = '08xdp';
            } else if (val == '01' || this.userInfo.businessGroup == '物贸') {
              this.formData.goldenTaxType = '';
              this.$nextTick(() => {
                this.$refs['topData']?.$refs['ruleForm']?.clearValidate('goldenTaxType');
              });
            } else {
              this.formData.goldenTaxType = '025';
            }
          }

          console.log('业务类别发生变化', val, this.formData.goldenTaxDate);
        },
      },
    },
    data() {
      return {
        belongDate: '',
        formData: {
          openBankCode: '', // 开户银行
          openBankName: '', // 开户银行名称
          bankAccount: '', // 银行账号
          creditCode: '', // 统一社会信用代码
          partnerAddress: '', // 客户地址
          goldenTaxType: '025', // 增值税发票类型
          goldenTaxDate: '', // 开票日期
          partnerPhone: '', // 联系方式
          goldenTaxStatus: '', // 金税发票单据状态
          ifPersonalPartner: '',
          partnerEmail: '',
          invoiceProperty: '', //（1个人，0企业）
          mobilePhone: '', // 移动电话
        },
        bankInfoList: [], //所有账号信息
        accoutList: [], //过滤过银行后的账号列表
        bankList: [], //去重后的银行列表
      };
    },
    mounted() {},
    methods: {
      setInit(params) {
        Object.keys(this.formData).forEach((key) => {
          console.log(key);
          this.formData[key] = params[key];
        });
      },
      handleChange(v, prop) {
        console.log(v, prop, v[prop]);
        this.formData[prop] = v[prop];
      },

      // 校验
      getVal() {
        return new Promise((resolve) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              // if (this.formData.ifPersonalPartner == 1) {
              //   if (this.formData.mobilePhone || this.formData.partnerPhone) {
              //     resolve(true);
              //   } else {
              //     this.$message.error('联系方式或邮箱必须要有一个不为空');
              //     resolve(false);
              //   }
              // } else {

              // }
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rate .el-form-item__content {
    display: flex;
  }
</style>
